<template>
    <div class="form-group p-2">
        <!-------------------------------------SERVICEACCOUNT MENU---------------------------------------------------------------------->
        <div v-if="!selectRepo" class="d-flex flex-row flex-align-baseline py-2">
            <b>{{ $t("Select a service account and connect") }}:*</b>
        </div>
        <!-------------------------------------REPOSITORY MENU---------------------------------------------------------------------->
        <div v-else class="d-flex flex-row flex-align-baseline py-2">
            <b>{{ $t("Select a repository and connect") }}:*</b>
        </div>


        <div class="row m-0">
            <!--SELECT REPOSITORY-->
            <select v-if="selectRepo" data-role="select" data-filter="false" :model="index_Repo" @change="onChange" class="w-50"  :disabled="repositories.length == 0">
                <option v-for="(repo, index) in repositories" :key="repo.id"
                    class="p-0" :value="index" :selected="index_Repo == index">
                    {{ repo.name }}
                    <span class="p-0 mif-info float-right" />
                </option>
            </select>

            <!--SELECT SERVICE ACCOUNTS-->
            <select v-else data-role="select" data-filter="true" :model="idSA" @change="onChange" class="w-50" :disabled="serviceAccounts.length == 0">
                <option v-for="(sa, index) in serviceAccounts" class="p-0"
                    :key="sa.id" :value="index" :selected="index_SA == index">
                    {{ sa.name }}
                </option>
            </select>

            <!--TEST SERVICE ACCOUNT-->
            <div class="p-2" v-if="wait">
                <span class="mif-spinner2 fg-primary ani-spin ml-2" />
            </div>

            <a v-else @click="test" class="button secondary ml-2" :disabled="!enableTest" v-disable-tooltip:testDisabled_message
                :title="$t('Connect')"><svg width="24" height="24" fill="none" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M21.707 3.707a1 1 0 0 0-1.414-1.414L18.496 4.09a4.252 4.252 0 0 0-5.251.604l-1.068 1.069a1.75 1.75 0 0 0 0 2.474l3.585 3.586a1.75 1.75 0 0 0 2.475 0l1.068-1.068a4.252 4.252 0 0 0 .605-5.25l1.797-1.798ZM10.707 11.707a1 1 0 0 0-1.414-1.414l-1.47 1.47-.293-.293a.75.75 0 0 0-1.06 0l-1.775 1.775a4.252 4.252 0 0 0-.605 5.25l-1.797 1.798a1 1 0 1 0 1.414 1.414l1.798-1.797a4.252 4.252 0 0 0 5.25-.605l1.775-1.775a.75.75 0 0 0 0-1.06l-.293-.293 1.47-1.47a1 1 0 0 0-1.414-1.414l-1.47 1.47-1.586-1.586 1.47-1.47Z"
                        fill="#fff" />
                </svg>
            </a>

            <!--CREATE-->
            <a class="button secondary ml-2" :disabled="wait">
                <span v-if="selectRepo" class="mif-plus text-bold mif-2x" @click="$root.$emit('OPENREPOSITORYDIALOG', type)"
                    :title="$t('Create new repository')"/>
                <span v-else class="mif-plus text-bold mif-2x" @click="$root.$emit('OPENSERVICEACCOUNTDIALOG', types[0])" 
                    :title="$t('Create new service account')"></span>
            </a>

            <!--EDIT-->
            <a v-if="selectRepo && index_Repo != -1" class="button ml-2" :disabled="wait">
                <span class="mif-pencil mif-2x m-2"
                    @click="$root.$emit('OPENREPOSITORYDIALOG', repositories[index_Repo])"
                    :title="$t('Edit repository')"></span>
            </a>
            <a v-if="!selectRepo && index_SA != -1" class="button ml-2" :disabled="wait">
                <span class="mif-pencil mif-2x m-2"
                    @click="$root.$emit('OPENSERVICEACCOUNTDIALOG', serviceAccounts[index_SA])"
                    :title="$t('Edit service account')" ></span>
            </a>

            <!--RELOAD-->
            <a class="button ml-2" :title="$t(selectRepo ? 'Refresh repositories' : 'Refresh service accounts')">
                <span class="mif-loop2 mif-2x m-2" @click="reloadSAREPO" :disabled="wait" ></span>
            </a>

        </div>

        <!--<p v-if="!selectRepo && !pcForTestIsConnected" class="fg-red mt-2">
            <span>{{ $t("The computer that was selected to test the service account is not connected.") }}<br> 
                  {{ $t("Edit it to change the computer to use or select another service account.") }}
            </span>
        </p>-->
        <ClientMessageView ref="FMV_SARepoSelect" :commands="['testserviceaccount', 'cloudmethods']" class="mt-2"/>


    </div>
</template>

<script>
import { ClientMessage } from '../../utils/objects';
import { isValid, waitSeconds } from '../../utils/utilitiesmodule';
import { testServiceAccount } from '../../utils/entityMethods/serviceAccount';
import ClientMessageView from '../dialogs/view/ClientMessageView.vue';
//import SARepoView from '../dialogs/view/SARepoView.vue';

export default {
    name: "SARepoSelect",
    props: {
        type: [Number, Array],
        idSA: [Number, String],
        idRepo: [Number, String],
        selectRepo: Boolean
    },
    components: {
        ClientMessageView
        //SARepoView
    },
    data() {
        return {
            types: [],
            serviceAccounts: [],
            repositories: [],
            //selectRepo: false,
            index_SA: -1,
            index_Repo: -1,
            wait: false,
            testReady: true,
            SA_NOTSELECTED: -1,
            SA_SELECTED_NOTTESTED: 0,
            SA_TESTED: 1,

            testState: -1,

            testDisabled_message: "",

        }
    },

    computed: {
        pcForTestIsConnected() {
            if (this.selectRepo) {
                return true;
            }

            var selectedPCID=this.serviceAccounts[this.index_SA].options.lastTestPC;
            if (!isValid(selectedPCID)) {
                this.testDisabled_message="";
                return true;
            }

            if (this.$root.connectionsStates[selectedPCID]) {
                this.testDisabled_message="";
                return true;
            }

            selectedPCID=this.$session.getRoomPC()?.id;
            if (selectedPCID!=null&&this.$root.connectionsStates[selectedPCID]) {
                this.testDisabled_message="";
                return true;
            }

            this.testDisabled_message=this.$t("pc_not_connected_for_sa_test");
            this.setClientMessage(ClientMessage.warning_translated(this.testDisabled_message, null));

            return false;
        },
        enableTest() {
            if (this.index_SA==-1) {
                this.testDisabled_message=this.$t('Select and validate a service account');
                this.setClientMessage(ClientMessage.info_translated(this.testDisabled_message, null));
                return false;
            }

            if (this.index_SA!=-1&&this.testState!=this.SA_TESTED) {
                this.testDisabled_message=this.$t('Select and validate a service account');
                this.setClientMessage(ClientMessage.info_translated(this.testDisabled_message, null));
                return true;
            }

            if (this.testState==this.SA_TESTED) {
                this.testDisabled_message=this.$t("Service account already validated");

                return false;
            }

            this.setClientMessage(null);

            return this.pcForTestIsConnected;

        },

    },
    mounted() {
        let self=this;
        this.$root.$on("REFRESHSERVICEACCOUNTS", saToSelect => {
            self.reloadSAREPO();
            //self.serviceAccounts=self.$session.getServiceAccounts();
            self.selectSABy(-1, saToSelect.id);
        });

        this.$root.$on("REFRESHREPOSITORIES", repoToSelect => {
            if (!self.selectRepo) {
                return;
            }
            self.reloadSAREPO();
            //self.repositories=self.$session.getRepositories();
            self.selectRepoBy(-1, repoToSelect.id);
        });

        if (typeof this.type=='number')
            this.types=this.type.isMicrosoft365()
                ? this.$root.getMicrosoftTypes()
                :[this.type];
        else
            this.types=this.type;

        this.serviceAccounts.push(...this.$session.getServiceAccountsWithTypeIn(this.types));
        this.repositories.push(...this.$session.getRepositoriesWithTypeIn(this.types));

        if (this.selectRepo) {
            this.selectRepoBy(-1, this.idRepo);
        } else {
            this.selectSABy(-1, this.idSA);
        }

    },
    beforeDestroy: function() {
        this.$root.$off("REFRESHSERVICEACCOUNTS");
        this.$root.$off("REFRESHREPOSITORIES");
    },

    methods: {
        testServiceAccount,

        selectSABy(index, id) {
            try {
                var fakeResult;
                if (!this.selectRepo) {
                    this.index_Repo=-1;
                }

                if (index!=-1) {
                    this.index_SA=index;
                    this.testState=this.SA_SELECTED_NOTTESTED;
                    fakeResult={
                        ok: false,
                        okNumber: 0,
                        serviceAccount: this.serviceAccounts[this.index_SA],
                        repository: this.index_Repo==-1? null:this.repositories[this.index_Repo],
                        client: null,
                        list: null
                    };
                    this.$emit("sendSATestResult", fakeResult);
                    return;
                }

                if (id!=-2) {
                    this.index_SA=this.serviceAccounts.findIndex(sa => sa.id==id);
                    if (this.index_SA!=-1) {
                        this.testState=this.SA_SELECTED_NOTTESTED;
                        fakeResult={
                            ok: false,
                            okNumber: 0,
                            serviceAccount: this.serviceAccounts[this.index_SA],
                            repository: this.index_Repo==-1? null:this.repositories[this.index_Repo],
                            client: null,
                            list: null
                        };
                        this.$emit("sendSATestResult", fakeResult);
                        return;
                    }

                    //this.$root.toast(this.$t(SERVICEACCOUNT_MESSAGES.NOT_RETRIEVED), "warning");
                    return this.selectSABy(-1, -2);
                }

                //Se: non è stato passato né l'indice, né l'id, seleziono di default il primo service account del tipo passato
                if (this.serviceAccounts.length>0)
                    return this.selectSABy(0, -2);

                this.index_SA=-1;
                this.testState=this.SA_NOTSELECTED;
                fakeResult={
                    ok: false,
                    okNumber: 0,
                    serviceAccount: null,
                    repository: null,
                    client: null,
                    list: null
                };
                this.$emit("sendSATestResult", fakeResult);
            } catch (e) {
                console.writeError(e);
            }
        },

        selectRepoBy(index, id) {
            if (index!=-1) {
                this.index_Repo=index;
                this.selectSABy(-1, this.repositories[index].id_service_account);
                return;
            }

            if (id!=-2) {
                this.index_Repo=this.repositories.findIndex(repo => repo.id==id);
                if (this.index_Repo!=-1) {
                    this.selectSABy(-1, this.repositories[this.index_Repo].id_service_account);
                    return;
                }
                //this.$root.toast(this.$t(REPOSITORY_MESSAGES.NOT_RETRIEVED), "warning");
                return this.selectRepoBy(-1, -2);
            }


            //Se non è stato passato né l'indice, né l'id, seleziono di default il primo service account del tipo passato
            if (this.repositories.length>0)
                return this.selectRepoBy(0, -1);

            this.index_Repo=-1;
            this.index_SA=-1;
            this.testState=this.SA_NOTSELECTED;
        },

        onChange(event) {
            this.setClientMessage(null);
            if (!isValid(event.detail)||!isValid(event.detail.selected))
                return;

            if (this.selectRepo)
                this.selectRepoBy(parseInt(event.detail.selected[0].toString()), -2);
            else
                this.selectSABy(parseInt(event.detail.selected[0].toString()), -1);

        },


        reloadSAREPO() {
            this.serviceAccounts.update(this.$session.getServiceAccountsWithTypeIn(this.types));
            this.repositories.update(this.$session.getRepositoriesWithTypeIn(this.types));
            //this.$forceUpdate();
        },

        async test() {
            if (this.index_SA==-1)
                return;
            /**
             * {
             * ok : bool,
             * okNumber : 1 se ok, 0 se !ok
             * serviceAccount:
             * repository:
             * client:
             * list:
             * }
             */
            this.wait=true;

            var testResult=await this.testServiceAccount(this.serviceAccounts[this.index_SA], this.$session.getPCWithID(this.serviceAccounts[this.index_SA].options.selectedPCID));
            this.wait=false;
            if (testResult.ok) {
                this.testState=this.SA_TESTED;
                this.serviceAccounts[this.index_SA].options=testResult.serviceAccount.options;


                if (this.index_Repo!=-1) {
                    testResult.repository=this.repositories[this.index_Repo];
                }
                this.$emit("sendSATestResult", testResult);
                return;
            }


            this.testState=this.SA_SELECTED_NOTTESTED;

        },

        setClientMessage(clientMessage) {
            if (this.$refs.FMV_SARepoSelect) {
                this.$refs.FMV_SARepoSelect.setClientMessage(clientMessage);

            } else {
                waitSeconds(1).then(() => {
                    this.$refs.FMV_SARepoSelect.setClientMessage(clientMessage);
                });
            }
        }

    }
}

</script>
